import { Directory, File } from '../generated';

export interface withTypename {
  __typename: string;
}

export const isFile = (s: withTypename): s is File => s.__typename === 'File';

export const isDirectory = (s: withTypename): s is Directory =>
  s.__typename === 'Directory';
